import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  text-align: center;\n  align-items: center;\n  padding: 0 8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
var StyledEllipsis = styled.span(_templateObject());
export default function renderEllipsis(_ref) {
  var key = _ref.key;
  return /*#__PURE__*/React.createElement(StyledEllipsis, {
    key: key
  }, "...");
}